<template>
  <div class="additional-info">
    <span class="text-muted mb-2">{{ $t('fleetTaskInstant.field.driverDocument') }}</span>

    <div class="additional-info__driver-documents">
      <div v-for="(attachment, idx) in driverAttachments" :key="attachment.id" class="attachment">
        <div
          class="attachment__wrapper"
          :class="
            attachment.type === 'FLEET_TASK_INSTANT_DRIVER_ATTACHMENT_PHOTO' ? '__photo' : '__file'
          "
          @click="activeAttachmentIdx = idx"
        >
          <img
            v-if="attachment.name.endsWith('pdf')"
            src="@/assets/images/download-format/pdf.png"
            alt
          />

          <img
            v-else-if="attachment.name.endsWith('xlsx')"
            src="@/assets/images/download-format/excel.png"
            alt
          />

          <img v-else :src="attachment.url" alt />
        </div>
        <p class="attachment__name">{{ attachment.name }}</p>
      </div>
    </div>

    <PreviewImage
      v-if="activeAttachmentIdx !== null"
      :attachments="driverAttachments"
      :activeAttachmentIdx="activeAttachmentIdx"
      :customHandlers="customHandlers"
      @update:activeAttachmentIdx="activeAttachmentIdx = $event"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import PreviewImage from '../../PreviewImage'

export default {
  components: {
    PreviewImage,
  },
  data() {
    return {
      activeAttachmentIdx: null,
      customHandlers: {
        handleDownloadImg: async (imgUrl, fileName, file) => {
          const res = await fetch(imgUrl, {
            headers: new Headers({
              'Cache-Control': 'no-cache',
            }),
          })
          if (!res) return

          const blob = await res.blob()
          const url = URL.createObjectURL(blob)
          Object.assign(document.createElement('a'), { href: url, download: file.name }).click()
          URL.revokeObjectURL(url)
        },

        handlePathUrl: (file) => {
          return file.url
        },
      },
    }
  },
  computed: {
    ...mapState('fleetTaskInstant', ['liveTrackResponse']),
    driverAttachments() {
      const attachments = []

      this.liveTrackResponse?.detail.attachment?.photos.forEach((item) => {
        attachments.push({
          id: item.id,
          name: item.file_name,
          url: item.url,
          type: item.type,
        })
      })

      this.liveTrackResponse?.detail.attachment?.documents.forEach((item) => {
        attachments.push({
          id: item.id,
          name: item.file_name,
          url: item.url,
          type: item.type,
        })
      })

      return attachments
    },
  },
}
</script>

<style lang="scss" scoped>
.additional-info {
  display: flex;
  flex-direction: column;

  &__driver-documents {
    display: flex;
    gap: 8px;
    flex-wrap: wrap;
  }

  .attachment {
    position: relative;
    max-width: 70px;

    &__wrapper {
      width: 70px;
      height: 70px;
      border-radius: 4px;
      overflow: hidden;
      cursor: pointer;

      img {
        object-fit: cover;
      }

      &.__photo {
        img {
          width: 100%;
          height: 100%;
        }
      }

      &.__file {
        border: 1px dashed $mep-color-text-300;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    &__name {
      margin-top: 8px;
      font-size: 0.8em;
      font-weight: 600;
      text-align: center;

      width: 70px;
      overflow: hidden;

      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;

      color: $primary;
    }

    .__delete-btn {
      position: absolute;
      top: 3px;
      right: 3px;
      height: 18px;
      width: 18px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid $red;
      border-radius: 3px;
      background-color: $white;

      i::before {
        font-size: 13px;
        color: $red;
      }
    }

    .__delete-btn:hover {
      background-color: $red;

      i::before {
        color: $white;
      }
    }
  }
}
</style>
